












import Vue from 'vue';
import { mapActions } from 'vuex';
import { HubLoading } from '@/components/HubComponents';

export default Vue.extend({
  name: 'ViewCallbackFacebook',

  components: { HubLoading },

  mounted() {
    // Transforma o "query parameter" em um objeto
    const search = window.location.search.substring(1);
    const queryParameterObject = JSON.parse(
      `{"${
        decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"')
      }"}`,
    ) as { hash: string; user_id: string };

    this.getUser(queryParameterObject.user_id)
      .then((user) => {
        if (user.id) {
          this.$router.push({
            name: 'FacebookSettings',
            params: {
              userDataString: JSON.stringify(user),
              hash: queryParameterObject.hash,
            },
          });
        } else {
          console.error('requestFacebookToken error');

          this.showNotification({
            text: 'facebook_account_error',
            type: 'error',
          });

          this.redirectsToViewLiveSocial(queryParameterObject.hash);
        }
      })
      .catch(() => this.redirectsToViewLiveSocial(queryParameterObject.hash));
  },

  methods: {
    ...mapActions({
      showNotification: 'notification/create',
      facebookGetUser: 'liveSocial/facebookGetUser',
    }),
    getUser(userId: string): Promise<Store.LiveSocial.Facebook.UserData> {
      return this.facebookGetUser(userId);
    },
    redirectsToViewLiveSocial(hash: string): void {
      this.$router.push({ name: 'LiveSocial', params: { hash } });
    },
  },
});
